/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedCeproDocCreateRequest } from '../types/PatchedCeproDocCreate';
import type { CeproDocCreateResponse } from '../types/CeproDocCreate';

export type CeproDocsClosePartialUpdateRequest = PatchedCeproDocCreateRequest;
export type CeproDocsClosePartialUpdateResponse = CeproDocCreateResponse;

export type CeproDocsClosePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cepro_docs/{id}/close/
 *
 * ```yaml
 * operationId: cepro_docs_close_partial_update
 * description: Je zde pouze jako nouzovka v případě, že by lehla automatika.
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsClosePartialUpdateOperation = ({
  id,
  ...rest
}: CeproDocsClosePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cepro_docs/${id}/close/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/close/' };
  };

/**
 * PATCH /dmx-server/cepro_docs/{id}/close/
 *
 * ```yaml
 * operationId: cepro_docs_close_partial_update
 * description: Je zde pouze jako nouzovka v případě, že by lehla automatika.
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocCreate'
 *     description: ''
 * ```
 */
export const ceproDocsClosePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsClosePartialUpdateQuery;
  request: PatchedCeproDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<CeproDocCreateResponse>> => {
  const operation = ceproDocsClosePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
